import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { apiDelete, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { KnmPublishStatusesEnum } from '../enums/KnmPublishStatusesEnum';
import { IKnm } from '../interfaces/IKnm';
import { IKnmAttachment } from '../interfaces/IKnmAttachment';
import { IKnmCancelRequest } from '../interfaces/IKnmCancelRequest';
import { IKnmDisapproveRequest } from '../interfaces/IKnmDisapproveRequest';
import { IKnmDurationUpdate } from '../interfaces/IKnmDurationUpdate';
import { IKnmStartDateUpdate } from '../interfaces/IKnmStartDateUpdate';
import { IKnmApproveRemark248 } from '../interfaces/IKnmApproveRemark248';

export async function fetchKnmRestoreById(id: number): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/restore`);
}

export async function fetchKnmPublishById(id: number): Promise<KnmPublishStatusesEnum | null> {
  return apiPut<KnmPublishStatusesEnum | null>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/publish`);
}

export async function fetchKnmUnpublishById(id: number): Promise<KnmPublishStatusesEnum | null> {
  return apiDelete<KnmPublishStatusesEnum | null>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/publish`);
}

export async function fetchKnmsCancel(data: IKnmCancelRequest): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/cancel`, data);
}

export async function fetchKnmsDisapprove(data: IKnmDisapproveRequest): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/disapprove`, data);
}

export async function fetchKnmToRevision(id: number, comment?: string): Promise<IKnmStatus> {
  return apiPut<IKnmStatus>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/to-revision`, comment);
}

export async function fetchKnmToApprove(id: number, comment?: string): Promise<IKnmStatus> {
  return apiPut<IKnmStatus>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/to-approve`, comment);
}

export async function fetchKnmsUpdateStartDate(data: IKnmStartDateUpdate): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/update-start-date`, data);
}

export async function fetchKnmAttachWebDocument(id: number, data: IKnmAttachment): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/attach-web-document`, data);
}

export async function fetchKnmsUpdateDuration(data: IKnmDurationUpdate): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/update-duration`, data);
}

export async function fetchKnmComplete336ById(knmId: number): Promise<IKnm> {
  return apiPut<IKnm>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/complete336/${knmId}`);
}

export async function fetchKnmApproveNote(knmIds: number[], note: string): Promise<void> {
  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/approve/note`, body: { knmIds, note } });
}

export async function fetchKnmExclude(knmIds: number[]): Promise<void> {
  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/exclude`, body: { knmIds } });
}

export async function fetchKnmApprove(knmIds: number[]): Promise<void> {
  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/approve`, body: { knmIds } });
}

export async function fetchKnmCopyById(id: number): Promise<IKnm> {
  return apiPost<IKnm>({ url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/copy` });
}

export async function fetchKnmApproveRemarks(
  knmIds: number[],
  remarks: IKnmApproveRemark248[],
  note: string,
): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/approve/remarks`,
    body: { knmIds, remarks, note },
  });
}
